import React from 'react'
import style from './style.css'

export default (props) => (
    <input
        className={`${style.text} ${(props.transparent) ? style.transparent : ''} ${props.className || ''}`}
        type='password'
        defaultValue={props.defaultValue}
        value={props.value}
        placeholder={props.placeholder || ''}
        onChange={props.handleChange || null}
        name={props.name || ''}
        style={props.style || {}}
        disabled={props.disabled}

        />
)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Forms/password.js